import type { ManagedIdentityResponseRecord } from '../types/trapi';
import { toOwnerDisplayRows } from './ownership';

export interface ManagedIdentityEditorRecord {
  id: string;
  apiPath: string;
  name: string;
  owners: string[];
  ownerDisplayTexts: string[];
  primaryOwnerId: string;
  primaryUnresolved: boolean;
  unresolvedCount: number;
  startDate: string;
  endDate: string;
}

export function toManagedIdentityEditorRecord(
  value: ManagedIdentityResponseRecord,
  fallbackApiPath = '',
): ManagedIdentityEditorRecord | null {
  if (!value || typeof value !== 'object') return null;
  const rows = toOwnerDisplayRows(value);
  const primaryRow = rows.find(row => row.isPrimary);
  const apiPath = ('apiPath' in value && typeof value.apiPath === 'string' ? value.apiPath : fallbackApiPath).trim();
  const id = typeof value.id === 'string' ? value.id : '';
  const name = 'name' in value && typeof value.name === 'string' ? value.name : '';
  const startDate = 'startDate' in value && typeof value.startDate === 'string' ? value.startDate : '';
  const endDate = 'endDate' in value && typeof value.endDate === 'string' ? value.endDate : '';

  return {
    id,
    apiPath,
    name,
    owners: rows.filter(row => row.editable).map(row => row.value),
    ownerDisplayTexts: rows.map(row => row.text),
    primaryOwnerId: primaryRow?.editable ? primaryRow.value : '',
    primaryUnresolved: !!primaryRow && !primaryRow.editable,
    unresolvedCount: rows.filter(row => !row.editable).length,
    startDate,
    endDate,
  };
}
